import React, { useState, useEffect, useImperativeHandle, useRef } from 'react';
import './index.css'
import { Popconfirm,Textarea,  Tooltip } from 'tdesign-react';

// theme : primary | star
export default ({ currentKey,onChoose,keyPrompt = '',maxPrompt =128, setShowConfirm, keyVal, theme = 'primary', content, onClose, onConfirm}) => {
  const [promt, setPromt] = useState(keyPrompt);
  const TagContent = () => {
    return <>
      <h4 className="ocrDemo-popConfirm__title">提示词</h4>
      <p className="ocrDemo-popConfirm__describe">
        <Textarea
          placeholder="如需提升字段抽取效果；可以添加字段的描述，比如相近词、详细描述"
          value={promt}
          max={maxPrompt}
          rows={3}
          onChange={(value) => {
            setPromt(value);
          }}
          onBlur={() => {
            setShowConfirm(false)
          }}
        />
      </p>
    </>
  }

  return (<>
    <Popconfirm
      content={TagContent()}
      visible={keyVal === currentKey}
      icon={<></>}
      destroyOnClose
      placement="bottom"
      showArrow
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onCancel={() => {
        setShowConfirm(false);
      }}
      onConfirm={() => {
        setShowConfirm(false);

        onConfirm({
          KeyPrompt: promt,
          keyName: content,
          Key:keyVal
        })
      }}
      theme="default">
      <span>
        <Tooltip theme="light" content={keyPrompt}>
          <div className={`ocrDemo-tag-container ${theme}`}
            onClick={(e) => {
              setShowConfirm(true);
              onChoose(keyVal)
            }}>
            <div className="ocrDemo-tag__border"></div>
            <div className="ocrDemo-tag__bg"></div>
            <div className="ocrDemo-tag__content">
              {content}
            </div>
            <div className="ocrDemo-tag__close"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose(content, keyVal)
              }}
            ></div>
            <div className="ocrDemo-tag__star" ></div>
          </div>
        </Tooltip>
      </span>
    </Popconfirm>
    {
      keyVal === currentKey && 
    <div className="ocrDemo-popconfirm-mask" onClick={() => {
      setShowConfirm(false);
    }}></div>

    }
  </>)
}